module.exports = __webpack_public_path__ + "img/psu.c6476913.png";